module.exports = __webpack_public_path__ + "media/honey-icons/icon-device-page-ef9144c6.svg";